import { styled, TextField } from "@mui/material";

export const CustomTextField = styled(TextField)({
	"& .MuiFormHelperText-root": {
		color: "#e5453b !important",
	},
	"& label": {
		fontSize: 14,
		color: "#2c2f44",
		fontFamily: "SF Pro Text Light",
		textTransform: "inherit",
	},

	"& label.MuiInputLabel-shrink": {
		fontSize: "0.9rem",
	},
	"& label.Mui-focused": {
		color: "#638dff",
	},
	"& .MuiInput-underline:after": {
		borderBottomColor: "green",
	},
	"& .MuiOutlinedInput-root": {
		fontSize: "0.8rem",
        fontWeight: "400",
		borderRadius: 8,
		fontFamily: "SF Pro Text Regular",
		color: "#2c2f44",
		backgroundColor: "#F4F4F4",
        padding: "2px !important",
        "& input": {
            padding: "7.5px 6px 7.5px 16px !important",
        },
		"& fieldset": {
			borderColor: "#c4d8ff",
		},
		"&:hover fieldset": {
			borderColor: "#92afff",
		},
		"&.Mui-disabled": {
			backgroundColor: "#f4f7fb !important",
			"& fieldset": {
				borderColor: "#c4d8ff",
			},
		},
		"&.Mui-error": {
			"& fieldset": {
				borderColor: "#f2a29d !important",
			},
		},
		"&.Mui-focused fieldset": {
			borderColor: "#638dff",
		},
		"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
			borderWidth: "1px !important",
		},
		"& .MuiOutlinedInput-input.Mui-disabled": {
			color: "#44485a",
			"-webkit-text-fill-color": "#44485a",
		},
	},
});